module.exports = {
  'en': {
    'HRES63UC1': {
      '0': 'List of Leave Application',
      '10': '[HRES63U] List of Leave Application',
      '20': 'No.',
      '30': 'Emp. Code',
      '40': 'Name',
      '50': 'Department',
      '60': 'Position',
      '70': 'Req. Date',
      '80': 'Seq No.',
      '90': 'Leave Code',
      '100': 'Leave Period',
      '110': 'Status',
      '120': 'Approved By',
      '130': 'Appr.Date',
      '140': 'Remark',
      '150': 'Next Approve'
    },
    'HRES63UC2': {
      '0': 'Details of Approve',
      '10': 'Details of Approve',
      '20': 'For Employee',
      '30': 'Seq. No',
      '40': 'Approved By',
      '50': 'Approved Date',
      '60': 'Current Status',
      '70': 'Status',
      '80': 'Approved',
      '90': 'Refused',
      '100': 'Remark',
      '110': 'No.of selected',
      '120': 'Record'
    },
    'HRES63UC3': {
      '0': 'Detail of Leave',
      '10': 'Detail of Leave',
      '20': 'Leave Code',
      '30': 'Description',
      '40': 'From Date',
      '50': 'Time',
      '60': 'To Date',
      '70': 'Time',
      '80': 'Leave Entitlement',
      '90': 'History of Leave',
      '100': 'Employee name',
      '110': 'Request date',
      '120': 'Attach File',
      '130': 'Update By'
    },
    'HRES63UC4': {
      '0': 'Leave Entitlement',
      '10': 'Leave Entitlement',
      '20': 'Emp. Code',
      '30': 'Leave Code',
      '40': 'Leave limit',
      '50': 'Per Time',
      '60': 'Per Year',
      '70': 'Day',
      '80': 'Hour',
      '90': 'Min.',
      '100': 'No.of day entitled',
      '110': 'Acc. Leave',
      '120': 'Balance',
      '130': 'Total Request'
    },
    'HRES63UC5': {
      '0': 'History of Leave',
      '10': 'History of Leave',
      '20': 'Emp.Code',
      '30': 'From Date',
      '40': 'To Date',
      '50': 'Date',
      '60': 'Shift',
      '70': 'Leave Period',
      '80': 'Leave Code',
      '90': 'Details of leave',
      '100': 'Leave Hrs.',
      '110': '(Hrs.:Min.)',
      '120': 'Application No.'
    },
    'HRES63UC6': {
      '10': 'List of Leave Request',
      '20': 'From Date',
      '30': 'To Date',
      '40': 'For Department',
      '50': 'Shift',
      '60': 'Date',
      '70': 'Shift',
      '80': 'Work Time',
      '90': 'Seq.No.',
      '100': 'Employee name',
      '110': 'Employee code',
      '120': 'Leave Code',
      '130': 'Leave Period',
      '140': 'From',
      '150': 'To'
    },
    'HRMS55XC1': {
      '0': 'รายละเอียดการลาหยุดงานของพนักงาน',
      '10': 'Employee Code',
      '20': 'or Department',
      '30': 'From Date',
      '40': 'To',
      '50': 'Type Of Leave'
    },
    'HRMS55XC2': {
      '10': 'Employee Code',
      '20': 'Employee Name',
      '30': 'Working Date',
      '40': 'Shift Code',
      '50': 'Time In - Out',
      '60': 'Leave Code',
      '70': 'Leave Description',
      '80': 'Duration of Leave',
      '90': 'Hours of leave',
      '100': 'Request Status'
    }
  },
  'th': {
    'HRES63UC1': {
      '0': 'อนุมัติการลาหยุดงาน',
      '10': '[HRES63U] อนุมัติการลาหยุดงาน',
      '20': 'ลำดับที่',
      '30': 'รหัสพนักงาน',
      '40': 'ชื่อ',
      '50': 'หน่วยงาน',
      '60': 'ตำแหน่ง',
      '70': 'วันที่ขอ',
      '80': 'ลำดับที่',
      '90': 'รหัสการลา',
      '100': 'ช่วงวันที่ขอลา',
      '110': 'สถานะ',
      '120': 'ผู้อนุมัติ',
      '130': 'วันที่อนุมัติ',
      '140': 'หมายเหตุการอนุมัติ',
      '150': 'ผู้อนุมัติลำดับถัดไป'
    },
    'HRES63UC2': {
      '0': 'รายละเอียดการอนุมัติ',
      '10': 'รายละเอียดการอนุมัติ',
      '20': 'สำหรับพนักงาน',
      '30': 'ลำดับที่อนุมัติ',
      '40': 'อนุมัติโดย',
      '50': 'วันที่อนุมัติ',
      '60': 'สถานะปัจจุบัน',
      '70': 'สถานะ',
      '80': 'อนุมัติ',
      '90': 'ไม่อนุมัติ',
      '100': 'หมายเหตุ',
      '110': 'รายการที่เลือกทั้งหมด',
      '120': 'รายการ'
    },
    'HRES63UC3': {
      '0': 'รายละเอียดใบลา',
      '10': 'รายละเอียดใบลา',
      '20': 'รหัสการลา',
      '30': 'รายละเอียด',
      '40': 'ตั้งแต่วันที่',
      '50': 'เริ่มเวลา',
      '60': 'ถึงวันที่',
      '70': 'ถึงเวลา',
      '80': 'สิทธิการลาหยุดงาน',
      '90': 'ประวัติการลา',
      '100': 'รหัสพนักงาน',
      '110': 'วันที่ขอ',
      '120': 'ไฟล์เอกสาร',
      '130': 'ผู้บันทึก'
    },
    'HRES63UC4': {
      '0': 'สิทธิการลาหยุดงาน',
      '10': 'สิทธิการลาหยุดงาน',
      '20': 'รหัสพนักงาน',
      '30': 'ประเภทการลา',
      '40': 'การนับสิทธิ์การลา',
      '50': 'ต่อครั้ง',
      '60': 'ต่อปี',
      '70': 'วัน',
      '80': 'ชม.',
      '90': 'นาที',
      '100': 'จำนวนวันลาที่มีสิทธิ์',
      '110': 'จำนวนวันที่ลา',
      '120': 'จำนวนวันคงเหลือ',
      '130': 'จำนวนวันขอลาสะสม'
    },
    'HRES63UC5': {
      '0': 'ประวัติการลา',
      '10': 'ประวัติการลา',
      '20': 'รหัสพนักงาน',
      '30': 'ตั้งแต่วันที่',
      '40': 'ถึงวันที่',
      '50': 'วันที่',
      '60': 'รหัสกะ',
      '70': 'ช่วงเวลาที่ลา',
      '80': 'รหัสการลา',
      '90': 'รายละเอียด',
      '100': 'ชม.การลา',
      '110': '(ชม.:นาที)',
      '120': 'เลขที่ใบลา'
    },
    'HRES63UC6': {
      '10': 'รายชื่อพนักงานที่ขอลาหยุดงาน',
      '20': 'ตั้งแต่วันที่',
      '30': 'ถึงวันที่',
      '40': 'สำหรับหน่วยงาน',
      '50': 'รหัสกะ',
      '60': 'วันที่',
      '70': 'รหัสกะ',
      '80': 'เวลาทำงาน',
      '90': 'ลำดับที่',
      '100': 'รหัสพนักงาน',
      '110': 'ชื่อพนักงาน',
      '120': 'รหัสการลา',
      '130': 'เวลาขอลาหยุด',
      '140': 'ตั้งแต่',
      '150': 'ถึง'
    },
    'HRMS55XC1': {
      '0': 'รายละเอียดการลาหยุดงานของพนักงาน',
      '10': 'รหัสพนักงาน',
      '20': 'หรือ หน่วยงาน',
      '30': 'ตั้งแต่วันที่',
      '40': 'ถึง',
      '50': 'ประเภทการลาที่ต้องการสอบถาม'
    },
    'HRMS55XC2': {
      '10': 'รหัสพนักงาน',
      '20': 'ชื่อพนักงาน',
      '30': 'วันที่ทำงาน',
      '40': 'รหัสกะ',
      '50': 'เวลาเข้า-ออก',
      '60': 'รหัสการลาหยุดงาน',
      '70': 'รายละเอียดรหัสการลา',
      '80': 'ระยะเวลาที่ขอลา',
      '90': 'ชั่วโมงลา',
      '100': 'สถานะคำร้อง'
    }
  }
}



// WEBPACK FOOTER //
// ./src/assets/labels/hres63u.js